"use client";

import { useAuth } from "@/app/hooks";
import { cn } from "@/app/lib/utils";
import { useAiSourceSelector } from "@/app/store/ai-source-selector";
import { useStateHistoryChatPage } from "@/app/store/chat";
import { AppVersion } from "./App-version";
import { TaiZenLogo } from "./TaiZenLogo";

type SidebarBrandHeaderProps = {
   isCollapsed: boolean;
   className?: string;
};

export const SidebarBrandHeader = ({
   isCollapsed,
   className
}: SidebarBrandHeaderProps) => {
   const { user } = useAuth();
   const { selectedBaseKnowledge } = useAiSourceSelector();
   const { selectedModel } = useStateHistoryChatPage();

   const showBrandText = !isCollapsed && Boolean(user?.id);
   const showAdminModel = Boolean(user?.isAdmin && selectedModel);

   return (
      <div
         className={cn(
            isCollapsed
               ? "flex flex-col items-center justify-center px-1.5 pt-3 pb-1 shrink-0"
               : "flex items-center gap-2 px-3 pt-3 pb-1 shrink-0",
            className
         )}
      >
         <div className="flex flex-col items-center shrink-0">
            <a
               href="/"
               className="dark:text-white text-black font-semibold flex items-center"
            >
               <TaiZenLogo
                  size="xxs"
                  className="w-10 h-10 border-2 border-spacing-1 rounded-full"
               />
            </a>
            <AppVersion
               className={cn(
                  "-mt-2 relative z-10 px-1 text-[9px]",
                  isCollapsed && "max-w-[52px] truncate"
               )}
            />
         </div>
         {showBrandText && (
            <div className="min-w-0 flex-1">
               <div className="font-semibold text-[13px] sm:text-sm leading-snug text-primary break-words">
                  {selectedBaseKnowledge?.name}
               </div>
               {showAdminModel && (
                  <div className="text-muted-foreground text-[10px] truncate">
                     <span>model: </span>
                     <code>{selectedModel}</code>
                  </div>
               )}
            </div>
         )}
      </div>
   );
};
